import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/icons/icon-close.svg'


const _withScopeId = n => (_pushScopeId("data-v-3f4de947"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, " Synonyms ", -1))
const _hoisted_3 = { class: "add" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("New")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Add a new synonym", -1))
const _hoisted_6 = { class: "info" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "languages" }
const _hoisted_9 = {
  key: 0,
  class: "name"
}
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_default_button = _resolveComponent("default-button")!
  const _component_language_tag = _resolveComponent("language-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_default_button, {
        onClick: _ctx.addSynonym,
        class: "button"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_5
    ]),
    _createElementVNode("section", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.synonyms, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "synonym",
          key: item.id
        }, [
          _createElementVNode("span", {
            onClick: ($event: any) => (_ctx.openLanguageModal(item)),
            class: "synonym-name"
          }, _toDisplayString(item.name), 9, _hoisted_7),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sliceLanguages(item.languages), (language) => {
              return (_openBlock(), _createElementBlock("div", {
                key: language,
                class: "name"
              }, [
                _createVNode(_component_language_tag, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(language.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128)),
            (item.languages.length > 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_language_tag, null, {
                    default: _withCtx(() => [
                      _createTextVNode("+" + _toDisplayString(item.languages.length - 3), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("img", {
              onClick: ($event: any) => (_ctx.openDeleteModal(item)),
              src: _imports_0,
              alt: "remove",
              class: "delete"
            }, null, 8, _hoisted_10)
          ])
        ]))
      }), 128))
    ])
  ]))
}